'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _retry = require('../utilities/retry');

var _retry2 = _interopRequireDefault(_retry);

var _poller = require('../utilities/poller');

var _poller2 = _interopRequireDefault(_poller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Responsible for polling for account balance changes
 *
 * @param {Object} services
 * @param {Object} actions
 *
 * @returns {function}
 */
exports.default = function (_ref, _ref2) {
  var eth = _ref.eth;
  var accountBalanceUpdate = _ref2.accountBalanceUpdate,
      accountBalanceUpdateFail = _ref2.accountBalanceUpdateFail;
  return function (store) {
    var dispatch = store.dispatch;

    return (0, _poller2.default)(store, {
      initialState: { currentBalance: null },
      frequency: 5000,
      checkStart: function checkStart(action, nextState, prevState) {
        return nextState.account.address !== prevState.account.address;
      },
      checkStop: function checkStop(action) {
        return action.type === 'APP_SHUTDOWN';
      },
      checkRun: function checkRun(state, reduxState) {
        return reduxState.account.address;
      },
      main: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(pollerState, _ref3) {
          var address = _ref3.account.address;
          var currentBalance, nextBalance;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  currentBalance = pollerState.currentBalance;
                  _context.prev = 1;
                  _context.next = 4;
                  return (0, _retry2.default)(function () {
                    return eth.fetchBalance(address);
                  });

                case 4:
                  nextBalance = _context.sent;

                  if (nextBalance !== currentBalance) {
                    dispatch(accountBalanceUpdate(address, nextBalance));
                    currentBalance = nextBalance;
                  }
                  _context.next = 11;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context['catch'](1);

                  dispatch(accountBalanceUpdateFail(address, _context.t0));

                case 11:
                  return _context.abrupt('return', { currentBalance: currentBalance });

                case 12:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined, [[1, 8]]);
        }));

        function main(_x, _x2) {
          return _ref4.apply(this, arguments);
        }

        return main;
      }()
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/middleware/pollAccountBalance.js
// module id = 1291
// module chunks = 0